import { CollapseProps } from 'antd';
import { FormikProps } from 'formik';

import { MFilter } from '@Components/Base';
import { useAppSelector } from '@Hooks/index';
import { DateRange, Input, MultiSelect } from '@Components/Filters';

import { getResumptionWorkShiftDict } from '@Store/selectors/dictionarySelector';
import { FilterForm } from './types';
import { getStatusLabels } from '../store/selectors/resumptionRequestSelectors';

interface FiltersProps {
  formik: FormikProps<FilterForm>;
  showError?: boolean;
}

const Filters: React.FC<FiltersProps> = ({ formik, showError = false }) => {
  const statuses = useAppSelector(getStatusLabels);
  const resumptionWorkShifts = useAppSelector(getResumptionWorkShiftDict);

  const workShiftLabels = resumptionWorkShifts.map(
    (workShift) => workShift.codeDesc
  );

  const items: CollapseProps['items'] = [
    {
      id: 'RESUMPTION DATE RANGE',
      label: 'Resumption Date Range',
      children: (
        <DateRange<FilterForm>
          formik={formik}
          fromKey="dateFrom"
          toKey="dateTo"
        />
      ),
    },
    {
      id: 'WORK SHIFT',
      label: 'Work Shift',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="workShift"
          options={workShiftLabels}
        />
      ),
    },
    {
      id: 'CURRENT LOCATION',
      label: 'Current Location',
      children: (
        <Input<FilterForm> formik={formik} formikKey="currentLocation" />
      ),
    },
    {
      id: 'STATUS',
      label: 'Status',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="statuses"
          options={statuses}
          showSearch
        />
      ),
    },
  ];

  return (
    <MFilter<FilterForm> showError={showError} formik={formik} items={items} />
  );
};

export default Filters;
